import { CalendarIconBeta } from "src/components/Icons";
import styled, {css} from "styled-components";
import { FilledButton } from "../Button/styles";

export const Container = styled.div`
  width: 334px;
  height: 272px;

  background-color: ${({
    theme: {
      colors: { dateFilterBackgroundColor },
    },
  }) => dateFilterBackgroundColor};
  position: absolute;
  cursor: default;
`;

export const Body = styled.div`
  & > p {
    color: ${(props) => props.theme.colors.secondary};
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 24px;
  }

  padding: 24px;

  & .cancelDateFilter, & .finishDateFilter {
    max-width: 90px;
    max-height: 40px;
    padding: 12px 16px;
  }
`;

export const InputsWrapper = styled.div`
  & .react-datepicker-wrapper input {
    background: transparent;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.text.default};
    height: 48px;

    font-size: 14px;
    color: ${(props) => props.theme.colors.text.default};
    font-weight: 600;

    ::-webkit-input-placeholder {
      font-size: 14px;
      color: ${(props) => props.theme.colors.text.default};
      font-weight: 600;
    }
  }

  min-height: calc(48px + 24px + 48px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & svg:not(.calendar-icon) {
    display: none;
  }
`;

export const CalendarContainer = styled.div`
  position: relative;
  background: transparent !important;

  &::after {
    content: "";
    position: absolute;
    right: calc(28px + 22px + 28px);
    top: 0;
    height: 100%;
    width: 1px;
    background: ${({ theme }) => theme.colors.text.default};
  }
  &:hover {
    svg {
      path {
        fill: ${({
          theme: {
            colors: {
              text: { default: whiteColor },
            },
          },
        }) => whiteColor};
      }
    }
    input {
      cursor: pointer;
    }
  }
  &:active {
    ${({
      theme: {
        colors: { secondary },
      },
    }) => css`
      svg {
        path {
          fill: ${secondary};
        }
      }
      input {
        ::placeholder {
          color: ${secondary};
        }
        color: ${secondary};
      }
    `}
  }
`;

export const CalendarIcon = styled(CalendarIconBeta)`
  fill: ${(props) => props.theme.colors.calendarBetaMonthFontColor}; 
  position: absolute;
  top: calc(50% - 11px);  
  right: 28px;
  pointer-events: none;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const FilterButton = styled(FilledButton)`
  background: ${(props) => props.disabled ? props.theme.colors.disabledMenuItem : ''};
  color: ${(props) => props.disabled ? props.theme.colors.menuItem : ''};
  pointer-events: ${(props) => props.disabled ? 'none' : ''};
`
